(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tatkraft-fire-finder"]) return;
  try {
    
(()=>{const ACCESSORIES=['lid','grate','plate','tripod','mast','pan','base','spark','cover','poker','pot'];
function number(value){if(value==null||String(value).trim()==='')return null;const s=String(value).trim();return /^\d+(?:[.,]\d+)?$/.test(s)?Number(s.replace(',','.')):NaN;}
function parse(raw={}){
 const q={shape:raw.shape||'any',size_mode:raw.size_mode||'exact',grip:raw.grip||'any',kind:raw.kind||'any',sort:raw.sort||'price',accessories:Array.isArray(raw.accessories)?[...new Set(raw.accessories)]:[]},errors=[];
 for(const [k,allowed] of Object.entries({shape:['any','round','square'],size_mode:['exact','min','max'],grip:['any','handles','ring','either','none'],kind:['any','bowl','set'],sort:['price','price_desc','size','height']}))if(!allowed.includes(q[k]))errors.push(k);
 for(const k of ['size','height_min','height_max']){q[k]=number(raw[k]);if(q[k]!==null&&(!Number.isFinite(q[k])||q[k]<=0||q[k]>500))errors.push(k);}
 if(q.height_min!==null&&q.height_max!==null&&q.height_min>q.height_max)errors.push('height_max');
 if(q.accessories.some(k=>!ACCESSORIES.includes(k)))errors.push('accessories');
 return {q,errors};
}
function findBowls(records,raw={}){
 const {q,errors}=parse(raw);if(errors.length)return {valid:false,errors,results:[],unknown:[],query:q};
 const results=[],unknown=[];
 for(const r of records){
  if(!r.available||q.shape!=='any'&&r.shape!==q.shape||q.kind!=='any'&&r.kind!==q.kind||q.accessories.some(k=>!r.accessories.includes(k)))continue;
  const missing=[];let failed=false;
  if(q.grip!=='any'){if(r.grip==='unknown')missing.push('grip');else if(q.grip==='either'?!['handles','ring'].includes(r.grip):r.grip!==q.grip)continue;}
  const s=r.shape==='square'?r.side:r.diameter;
  if(q.size!==null){if(s==null)missing.push('size');else if(q.size_mode==='exact'?Math.abs(s-q.size)>1e-8:q.size_mode==='min'?s+1e-8<q.size:s-q.size>1e-8)failed=true;}
  if(q.height_min!==null||q.height_max!==null){if(r.height==null)missing.push('height');else if(q.height_min!==null&&r.height+1e-8<q.height_min||q.height_max!==null&&r.height-q.height_max>1e-8)failed=true;}
  if(!failed)(missing.length?unknown:results).push({record:r,missing});
 }
 const compare=(a,b)=>{const key=q.sort==='size'?(r=>r.shape==='square'?r.side:r.diameter):q.sort==='height'?(r=>r.height):(r=>r.price);
 const av=key(a.record)??Infinity,bv=key(b.record)??Infinity;
 return av===bv?a.record.sku.localeCompare(b.record.sku):q.sort==='price_desc'?bv-av:av-bv;};
 results.sort(compare);unknown.sort(compare);
 return {valid:true,errors:[],results,unknown,query:q,hasFilters:q.size!==null||q.height_min!==null||q.height_max!==null||q.grip!=='any'||q.kind!=='any'||q.shape!=='any'||q.accessories.length>0};
}



const SCENARIOS={bowl:{kind:'bowl',accessories:[]},grate:{kind:'set',accessories:['grate']},plate:{kind:'set',accessories:['plate']},lid:{kind:'set',accessories:['lid']}};

function applyScenario(raw,key){const s=Object.hasOwn(SCENARIOS,key)?SCENARIOS[key]:null;if(!s)throw new RangeError('Unknown scenario');return {...raw,kind:s.kind,accessories:[...s.accessories]};}

function selectedScenario(raw){const a=Array.isArray(raw.accessories)?raw.accessories:[];return Object.keys(SCENARIOS).find(k=>{const s=SCENARIOS[k];return raw.kind===s.kind&&a.length===s.accessories.length&&a.every(x=>s.accessories.includes(x));})??null;}


function initFireFinder(root){

 if(root.dataset.fireReady)return;

 const config=JSON.parse(root.querySelector('[data-fire-config]').textContent),t=config.text;

 const form=root.querySelector('form'),grid=root.querySelector('[data-fire-grid]'),unknownGrid=root.querySelector('[data-fire-unknown-grid]');

 const cards=new Map(),records=[];

 document.querySelectorAll('[data-fire-catalog] [data-fire-card]').forEach(card=>{const r=JSON.parse(card.querySelector('[data-fire-record]').textContent);if(!cards.has(r.sku)){cards.set(r.sku,card);records.push(r);}});

 if(!records.length)return;

 root.dataset.fireReady='true';

 document.querySelectorAll('[data-fire-catalog]').forEach(el=>el.hidden=true);

 const count=root.querySelector('[data-fire-count]'),error=root.querySelector('[data-fire-error]'),unknownBox=root.querySelector('[data-fire-unknown]'),more=root.querySelector('[data-fire-more]');

 let visible=12,current=null,timer;

 const fmt=n=>new Intl.NumberFormat(config.locale,{maximumFractionDigits:2}).format(n);

 const escCount=(key,n)=>t[key].replace('{n}',fmt(n));

 const known=['size','size_mode','shape','height_min','height_max','grip','kind','sort'];

 function raw(){const f=new FormData(form);return Object.fromEntries([...known.map(k=>[k,f.get(k)]),['accessories',f.getAll('accessories')]]);}

 function urlUpdate(q){

  const url=new URL(window.location.href);

  for(const k of [...known,'accessories'])url.searchParams.delete(k);

  for(const k of known){const v=q[k],defaults={size_mode:'exact',shape:'any',grip:'any',kind:'any',sort:'price'};if(v!==null&&v!==''&&v!==defaults[k])url.searchParams.set(k,String(v));}

  for(const a of q.accessories)url.searchParams.append('accessories',a);

  window.history.replaceState(null,'',url);

 }

 function go(el,block='center'){el.focus({preventScroll:true});el.scrollIntoView({block,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}

 function summary(q){

  const parts=[];

  if(q.shape!=='any')parts.push(t.summary_shape+': '+t[q.shape]);

  if(q.size!==null)parts.push(t.summary_size+': '+t[q.size_mode]+' '+fmt(q.size)+' cm');

  if(q.height_min!==null||q.height_max!==null)parts.push(t.summary_height+': '+(q.height_min===q.height_max?fmt(q.height_min):q.height_min!==null&&q.height_max!==null?fmt(q.height_min)+'–'+fmt(q.height_max):q.height_min!==null?t.min+' '+fmt(q.height_min):t.max+' '+fmt(q.height_max))+' cm');

  if(q.grip!=='any')parts.push(t.summary_grip+': '+t[q.grip]);

  if(q.kind!=='any')parts.push(t.summary_kind+': '+t[q.kind]);

  if(q.accessories.length)parts.push(t.summary_accessories+': '+q.accessories.map(a=>t[a]).join(', '));

  return parts.join(' · ');

 }

 function render(options={}){

  const input=raw(),result=findBowls(records,input);current=result;

  root.querySelectorAll('[data-fire-scenario]').forEach(btn=>btn.setAttribute('aria-pressed',String(selectedScenario(input)===btn.dataset.fireScenario)));

  form.querySelectorAll('[aria-invalid]').forEach(el=>{el.removeAttribute('aria-invalid');el.removeAttribute('aria-describedby');});

  error.hidden=result.valid;grid.hidden=!result.valid;

  if(!result.valid){count.textContent=t.catalog;root.querySelectorAll('[data-fire-live-count]').forEach(el=>el.textContent='');root.querySelector('[data-fire-summary]').textContent='';unknownBox.hidden=true;root.querySelector('[data-fire-empty]').hidden=true;more.hidden=true;

   for(const k of result.errors){const el=form.elements.namedItem(k);if(el&&typeof el.setAttribute==='function'){el.setAttribute('aria-invalid','true');el.setAttribute('aria-describedby',error.id);}}

   if(options.submit){const el=form.elements.namedItem(result.errors[0]);if(el&&typeof el.focus==='function')go(el);}

   return;

  }

  const n=result.results.length;count.textContent=result.hasFilters?(n===1?t.count_one:escCount('count',n)):escCount('initial_count',n);

  root.querySelectorAll('[data-fire-live-count]').forEach(el=>el.textContent=String(n));

  root.querySelector('[data-fire-summary]').textContent=summary(result.query);

  for(const card of cards.values())card.hidden=true;

  for(let i=0;i<n;i++){const card=cards.get(result.results[i].record.sku);grid.append(card);card.hidden=i>=visible;card.querySelector('[data-fire-missing]').hidden=true;}

  const missingLabels={size:t.missing_size,height:t.missing_height,grip:t.missing_grip};

  for(const m of result.unknown){const card=cards.get(m.record.sku);unknownGrid.append(card);card.hidden=false;const note=card.querySelector('[data-fire-missing]');note.textContent=t.missing_prefix+m.missing.map(k=>missingLabels[k]).join(', ');note.hidden=false;}

  unknownBox.hidden=!result.unknown.length;

  root.querySelector('[data-fire-unknown-count]').textContent=t.unknown_title+' ('+result.unknown.length+')';

  if(!n&&result.unknown.length)unknownBox.open=true;

  root.querySelector('[data-fire-empty]').hidden=n!==0;

  const left=n-visible;more.hidden=left<=0;more.textContent=escCount('more',Math.min(12,Math.max(0,left)));

  if(options.url)urlUpdate(result.query);

  if(options.submit)go(count,'start');

 }

 const params=new URLSearchParams(window.location.search);

 for(const k of known)if(params.has(k)&&form.elements.namedItem(k))form.elements.namedItem(k).value=params.get(k);

 const selected=params.getAll('accessories');form.querySelectorAll('[name="accessories"]').forEach(el=>el.checked=selected.includes(el.value));

 root.querySelectorAll('[data-fire-scenario]').forEach(btn=>btn.addEventListener('click',()=>{clearTimeout(timer);const next=applyScenario(raw(),btn.dataset.fireScenario);form.elements.namedItem('kind').value=next.kind;form.querySelectorAll('[name="accessories"]').forEach(el=>el.checked=next.accessories.includes(el.value));visible=12;render({url:true});}));

 form.addEventListener('submit' ,e=>{e.preventDefault();clearTimeout(timer);visible=12;render({submit:true,url:true});});

 form.addEventListener('change',()=>{clearTimeout(timer);visible=12;render({url:true});});

 root.querySelector('select[name="sort"]').addEventListener('change',()=>{visible=12;render({url:true});});

 form.addEventListener('input',e=>{if(e.target.tagName!=='INPUT'||e.target.type==='checkbox')return;clearTimeout(timer);timer=setTimeout(()=>{visible=12;render({url:true});},180);});

 root.querySelectorAll('[data-fire-quick]').forEach(btn=>btn.addEventListener('click',()=>{form.elements.namedItem('size').value=btn.dataset.fireQuick;visible=12;render({url:true});}));

 root.querySelector('[data-fire-reset]').addEventListener('click',()=>{form.reset();visible=12;render({url:true});go(form.querySelector('input'));});

 root.querySelector('[data-fire-clear-sizes]').addEventListener('click',()=>{for(const k of ['size','height_min','height_max'])form.elements.namedItem(k).value='';visible=12;render({url:true,submit:true});});

 more.addEventListener('click',()=>{const next=current.results[visible];visible+=12;render();if(next)go(cards.get(next.record.sku).querySelector('a'));});

 render();

}

const bootFireFinder=()=>document.querySelectorAll('[data-fire-finder]').forEach(initFireFinder);

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bootFireFinder,{once:true});else bootFireFinder();

document.addEventListener('shopify:section:load',bootFireFinder);



})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tatkraft-ladder-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
 'use strict';
 const OPEN_AXES=['width','depth','height'];
const FOLD_AXES=['fold_width','fold_depth','fold_height'];
const NUM_FIELDS=['steps','platform','load',...OPEN_AXES,...FOLD_AXES,'weight'];
function numeric(value){if(value===null||value===undefined||String(value).trim()==='')return null;const s=String(value).trim();if(!/^\d+(?:[.,]\d+)?$/.test(s))return NaN;return Number(s.replace(',','.'));}
function parseQuery(raw){const q={mode:raw.mode??'space',material:raw.material??'any',sort:raw.sort??'relevance'},errors=[];if(!['space','exact'].includes(q.mode))errors.push('mode');if(!['any','wood','aluminium','steel','metal'].includes(q.material))errors.push('material');if(!['relevance','price','price_desc','weight','platform'].includes(q.sort))errors.push('sort');for(const k of NUM_FIELDS){q[k]=numeric(raw[k]);if(q[k]!==null&&(!Number.isFinite(q[k])||q[k]<=0||q[k]>1000||k==='steps'&&(!Number.isInteger(q[k])||q[k]>20)))errors.push(k);}return {q,errors};}
function findLadders(records,raw){const{q,errors}=parseQuery(raw);if(errors.length)return {valid:false,errors,results:[],unknown:[],query:q};const results=[],unknown=[],active=NUM_FIELDS.filter(k=>q[k]!==null);for(const record of records){if(!record.available)continue;if(q.material!=='any'&&!(q.material==='metal'?record.materials.some(m=>['metal','steel','aluminium'].includes(m)):record.materials.includes(q.material)))continue;let failed=false;const missing=[];for(const k of active){const value=record[k];if(value===null||value===undefined){missing.push(k);continue;}if(k==='steps'?value!==q[k]:k==='load'||k==='platform'?value+1e-8<q[k]:OPEN_AXES.includes(k)&&q.mode==='exact'?false:value-q[k]>1e-8)failed=true;}if(failed)continue;const differences=Object.fromEntries(OPEN_AXES.map(k=>[k,q[k]===null||record[k]===null?null:record[k]-q[k]]));const hasDimensions=OPEN_AXES.some(k=>q[k]!==null);const score=OPEN_AXES.reduce((s,k)=>s+(differences[k]===null?0:Math.abs(differences[k])/q[k]),0);const exact=Object.values(differences).every(d=>d===null||Math.abs(d)<1e-8);const m={record,missing,differences,hasDimensions,group:missing.length?'unknown':q.mode==='exact'&&hasDimensions&&!exact?'alternative':'exact',score};(missing.length?unknown:results).push(m);}
const compare=(a,b)=>{if(q.mode==='exact'&&OPEN_AXES.some(k=>q[k]!==null)&&a.group!==b.group)return a.group==='exact'?-1:b.group==='exact'?1:0;if(q.sort==='price')return a.record.price-b.record.price;if(q.sort==='price_desc')return b.record.price-a.record.price;if(q.sort==='weight')return (a.record.weight??Infinity)-(b.record.weight??Infinity);if(q.sort==='platform')return (a.record.platform??Infinity)-(b.record.platform??Infinity);return a.score-b.score||a.record.steps-b.record.steps||a.record.price-b.record.price;};results.sort(compare);unknown.sort(compare);return {valid:true,errors:[],results,unknown,query:q,active,hasFilters:active.length>0||q.material!=='any'};}

 function init(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const config=JSON.parse(root.querySelector('[data-lf-config]').textContent),text=config.text,records=config.records,form=root.querySelector('form');
  const grid=root.querySelector('[data-lf-grid]'),unknown=root.querySelector('[data-lf-unknown]'),unknownGrid=root.querySelector('[data-lf-unknown-grid]'),count=root.querySelector('[data-lf-count]'),error=root.querySelector('[data-lf-error]'),empty=root.querySelector('[data-lf-empty]');
  const cards=new Map([...root.querySelectorAll('[data-lf-card]')].map(c=>[c.dataset.sku,c]));
  const fmt=v=>new Intl.NumberFormat(config.locale,{maximumFractionDigits:2}).format(Math.abs(v));
  const say=(k,values={})=>Object.entries(values).reduce((s,[key,v])=>s.replaceAll('{'+key+'}',String(v)),text[k]);
  const label=k=>text[k==='platform'?'platform_word':k==='load'?'load_word':k==='weight'?'weight_word':k==='steps'?'steps_label':k];
  function mode(){const v=form.elements.mode.value;OPEN_AXES.forEach(k=>root.querySelector('[data-lf-label="'+k+'"]').textContent=text[v+'_'+k]+' (cm)');}
  function render({scroll=false,write=true}={}){
   mode();const r=findLadders(records,Object.fromEntries(new FormData(form)));error.hidden=r.valid;grid.hidden=!r.valid;empty.hidden=true;unknown.hidden=true;
   form.querySelectorAll('[aria-invalid]').forEach(e=>e.removeAttribute('aria-invalid'));r.errors.forEach(k=>{const e=form.elements[k];if(e?.setAttribute)e.setAttribute('aria-invalid','true');});
   root.querySelectorAll('[data-lf-result-count]').forEach(e=>e.textContent=r.valid?say('short_count',{count:r.results.length}):'');
   grid.querySelectorAll('[data-lf-group]').forEach(e=>e.remove());cards.forEach(c=>{c.hidden=true;c.classList.remove('tklf__card--featured');});
   if(!r.valid){count.textContent=text.invalid_short;root.querySelector('[data-lf-summary]').textContent='';if(scroll)form.querySelector('[aria-invalid="true"]')?.focus();return;}
   const q=r.query;if(write){const url=new URL(location.href);for(const k of [...NUM_FIELDS,'mode','material','sort']){if(q[k]===null||q[k]==='')url.searchParams.delete(k);else url.searchParams.set(k,q[k]);}history.replaceState(null,'',url);}
   count.textContent=r.hasFilters?say('results',{count:r.results.length}):text.catalog;
   const criteria=r.active.map(k=>label(k)+': '+(k==='platform'?text.min_word+' ':k==='weight'||FOLD_AXES.includes(k)||OPEN_AXES.includes(k)&&q.mode==='space'?text.max_word+' ':'')+fmt(q[k])+(k==='steps'?'':k==='load'||k==='weight'?' kg':' cm'));
   if(q.material!=='any')criteria.push(text.material_label+': '+text[q.material]);root.querySelector('[data-lf-summary]').textContent=r.hasFilters?say('summary',{criteria:criteria.join(' · ')}):text.summary_all;
   empty.hidden=r.results.length>0;let group=null;
   function show(m,target,index){const c=cards.get(m.record.sku);if(!c)return;c.hidden=false;target.append(c);c.dataset.match=m.group;
    c.querySelector('[data-lf-badge]').textContent=m.group==='unknown'?text.badge_unknown:m.record.load===null?text.badge_unknown:m.group==='alternative'?text.badge_compare:r.hasFilters?text.badge_match:text.badge_all;
    const missing=c.querySelector('[data-lf-missing]');missing.hidden=m.missing.length===0;missing.textContent=m.missing.length?say('missing',{fields:m.missing.map(label).join(', ')}):'';
    const d=c.querySelector('[data-lf-differences]');d.replaceChildren();d.hidden=!m.hasDimensions;for(const axis of OPEN_AXES){const delta=m.differences[axis];if(delta===null)continue;const p=document.createElement('p');p.className='tklf__delta tklf__delta--'+axis;p.textContent=Math.abs(delta)<1e-8?say('same_axis',{axis:text[axis]}):delta<0?say('save_'+axis,{cm:fmt(delta)}):say('more_'+axis,{cm:fmt(delta)});d.append(p);}
    if(target===grid&&index===0)c.classList.add('tklf__card--featured');
   }
   r.results.forEach((m,i)=>{if(q.mode==='exact'&&m.hasDimensions&&m.group!==group){const h=document.createElement('h3');h.dataset.lfGroup='';h.className='tklf__group';h.textContent=text[m.group==='exact'?'exact_group':'other_group'];grid.append(h);if(m.group==='alternative'){const p=document.createElement('p');p.dataset.lfGroup='';p.className='tklf__group-help';p.textContent=text.other_help;grid.append(p);}group=m.group;}show(m,grid,i);});
   if(r.unknown.length){unknown.hidden=false;unknown.open=r.results.length===0;root.querySelector('[data-lf-unknown-count]').textContent=say('unknown_count',{count:r.unknown.length});r.unknown.forEach((m,i)=>show(m,unknownGrid,i));}
   if(scroll){count.focus({preventScroll:true});count.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  }
  const fields=[...NUM_FIELDS,'mode','material','sort'];
  function restore(){const p=new URLSearchParams(location.search);for(const k of fields){if(form.elements[k])form.elements[k].value=p.get(k)??(k==='mode'?'space':k==='material'?'any':k==='sort'?'relevance':'');}}
  restore();form.addEventListener('submit',e=>{e.preventDefault();render({scroll:true});});let timer;form.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(()=>render(),180);});root.addEventListener('change',()=>{clearTimeout(timer);render();});
  root.querySelector('[data-lf-reset]').addEventListener('click',()=>{clearTimeout(timer);form.reset();render();form.elements.steps.focus();});root.querySelector('[data-lf-clear-sizes]').addEventListener('click',()=>{[...OPEN_AXES,...FOLD_AXES,'weight'].forEach(k=>form.elements[k].value='');render({scroll:true});});
  window.addEventListener('popstate',()=>{restore();render({write:false});});render({write:false});
 }
 document.querySelectorAll('[data-ladder-finder]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ladder-finder]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tatkraft-rack-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
 'use strict';
 const AXES = ['width', 'depth', 'height'];
const EPS = 1e-7;
function toNumber(value) {
 if (typeof value === 'number') return Number.isFinite(value) && value > 0 ? value : null;
 if (typeof value !== 'string' || !/^\d+(?:[.,]\d+)?$/.test(value.trim())) return null;
 const number = Number(value.trim().replace(',', '.'));
 return Number.isFinite(number) && number > 0 ? number : null;
}
function normalize(input) {
 const load = toNumber(input.load), sizes = {};
 if (!load || load > 10000 || input.unit === 'jackets' && !Number.isInteger(load)) return null;
 for (const key of AXES) {
  const raw = input[key], empty = raw == null || typeof raw === 'string' && raw.trim() === '';
  sizes[key] = empty ? null : toNumber(raw);
  if (!empty && (sizes[key] === null || sizes[key] > 1000)) return null;
 }
 const wheels = input.wheels ?? 'any', profi = input.profi ?? 'any';
 if (!['kg','jackets'].includes(input.unit) || !['space','exact'].includes(input.mode) ||
     !['any','chrome','powder'].includes(input.finish) || !['any','rack','set'].includes(input.kind) ||
     !['any','yes','no'].includes(wheels) || !['any','yes'].includes(profi)) return null;
 return {...input, ...sizes, load, wheels, profi, requiredKg: input.unit === 'jackets' ? load * 2.5 : load};
}
function candidate(r, q, applyDimensions = true) {
 if (!q || !r.selectable || !r.available || q.profi === 'yes' && r.profi !== true) return null;
 const width = r.selectionWidth ?? r.width;
 if (!width || !r.height || ![...width,r.depth,...r.height].every(v => Number.isFinite(v) && v > 0) || width[0] > width[1] || r.height[0] > r.height[1]) return null;
 if (q.kind !== 'any' && r.kind !== q.kind || q.finish !== 'any' && r.finish !== q.finish || q.wheels !== 'any' && r.wheels !== q.wheels) return null;
 const known = Number.isFinite(r.hangingKg) && r.hangingKg > 0;
 if (known ? r.hangingKg + EPS < q.requiredKg : !Number.isFinite(r.totalKg) || r.totalKg + EPS < q.requiredKg) return null;
 const range = {width, depth:[r.depth,r.depth], height:r.height};
 const setting = {}, differences = {};
 for (const axis of AXES) {
  const wanted = q[axis], [min,max] = range[axis];
  if (applyDimensions && q.mode === 'space' && wanted !== null && min > wanted + EPS) return null;
  let value = wanted === null ? min : Math.min(max, Math.max(min,wanted));
  if (axis === 'height' && r.heightKind === 'steps_unknown') {
   const choices = r.height.filter(n => q.mode !== 'space' || wanted === null || n <= wanted + EPS);
   if (!choices.length && applyDimensions) return null;
   value = (choices.length ? choices : [min]).reduce((best,n) => wanted !== null && Math.abs(n-wanted) < Math.abs(best-wanted) ? n : best);
  }
  setting[axis] = value;
  differences[axis] = wanted === null ? null : value - wanted;
 }
 const active = AXES.filter(axis => q[axis] !== null);
 const exact = active.every(axis => Math.abs(differences[axis]) <= EPS);
 const distance = active.length ? active.reduce((sum,axis) => sum + Math.abs(differences[axis]) / q[axis],0) / active.length : 0;
 return {record:r, setting, differences, distance, exact, hasDimensions:active.length > 0,
         status:known ? 'confirmed' : 'review', capacity:known ? r.hangingKg : null,
         requiredKg:q.requiredKg, group: q.mode === 'exact' && active.length ? (exact ? 'exact' : 'alternative') : 'matching'};
}
function sortMatches(results, order = 'relevance') {
 return [...results].sort((a,b) => {
  const group = (a.group === 'alternative' ? 1 : 0) - (b.group === 'alternative' ? 1 : 0);
  if (group) return group;
  const price = (a.record.price ?? Infinity) - (b.record.price ?? Infinity);
  const capacity = (b.capacity ?? 0) - (a.capacity ?? 0);
  return (order === 'price' ? price : order === 'price_desc' ? -price : order === 'load' ? capacity : a.distance - b.distance) || price || a.record.model.localeCompare(b.record.model);
 });
}
function findRacks(records, input) {
 const q = normalize(input);
 if (!q) return {valid:false, results:[], reviewResults:[]};
 const all = records.map(r => candidate(r,q)).filter(Boolean);
 const confirmed = all.filter(m => m.status === 'confirmed');
 const potential = records.map(r => candidate(r,q,false)).filter(Boolean);
 const excludedBy = Object.fromEntries(AXES.map(axis => [axis,q[axis] === null || q.mode !== 'space' ? 0 : potential.filter(m => m.setting[axis] > q[axis] + EPS).length]));
 return {valid:true, query:q, results:sortMatches(confirmed), reviewResults:sortMatches(all.filter(m => m.status === 'review')),
         exactCount:confirmed.filter(m => m.group !== 'alternative').length,
         alternativeCount:confirmed.filter(m => m.group === 'alternative').length, excludedBy};
}

 function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const config = JSON.parse(root.querySelector('[data-rf-config]').textContent), text = config.text;
  const form = root.querySelector('[data-rf-form]'), cards = [...root.querySelectorAll('[data-rf-card]')];
  const get = name => form.elements.namedItem(name);
  const fmt = n => new Intl.NumberFormat(config.locale,{maximumFractionDigits:2}).format(n);
  const keys = ['load','unit','mode','width','depth','height','finish','kind','wheels','profi'];
  const sortControl = root.querySelector('[data-rf-sort]');
  const read = () => Object.fromEntries(keys.map(key => [key,get(key).value]));
  const count = root.querySelector('[data-rf-count]'), grid = root.querySelector('[data-rf-grid]');
  const review = root.querySelector('[data-rf-review]'), reviewGrid = root.querySelector('[data-rf-review-grid]');
  const jump = root.querySelector('[data-rf-jump]'), resultsArea = root.querySelector('[data-rf-results]');
  let previousUnit, resultCount = 0, timer, scrollFrame;
  function fromUrl() {
   const params = new URLSearchParams(location.search);
   for (const key of keys) {
    if (!params.has(key)) continue;
    const value = params.get(key), el = get(key);
    if (key === 'mode') { if (['exact','space'].includes(value)) el.value = value; }
    else if (el.tagName !== 'SELECT' || [...el.options].some(option => option.value === value)) el.value = value;
   }
   if ([...sortControl.options].some(option => option.value === params.get('sort'))) sortControl.value = params.get('sort');
   previousUnit = get('unit').value;
  }
  function updateUrl() {
   const url = new URL(location.href);
   for (const [key,value] of Object.entries({...read(),sort:sortControl.value})) url.searchParams.set(key,value);
   history.replaceState(null,'',url);
  }
  function unitLabels() {
   const jackets = get('unit').value === 'jackets';
   get('load').step = jackets ? '1' : '0.1';
   get('load').min = jackets ? '1' : '0.1';
   get('load').inputMode = jackets ? 'numeric' : 'decimal';
   root.querySelector('[data-rf-loadlabel]').textContent = jackets ? text.jacket_count : text.load;
   const n = toNumber(get('load').value);
   root.querySelector('[data-rf-equivalent]').textContent = n ? (jackets ? text.equivalent_kg : text.equivalent_jackets).replace('{n}',fmt(jackets ? n*2.5 : n/2.5)) : '';
  }
  function dimensionMode() {
   const mode = get('mode').value;
   for (const axis of AXES) root.querySelector('[data-rf-dimension="'+axis+'"]').textContent = text[mode+'_'+axis];
   root.querySelector('[data-rf-modehelp]').textContent = text[mode+'_help'];
  }
  function jumpVisibility() {
   const introRect = root.querySelector('h1').getBoundingClientRect(), resultsRect = resultsArea.getBoundingClientRect();
   jump.hidden = !resultCount || introRect.top >= innerHeight || resultsRect.top < innerHeight * 0.7 || innerWidth > 800;
  }
  function headingFor(group) {return group === 'exact' ? text.group_exact : group === 'alternative' ? text.group_alternative : text.group_matching;}
  function fillCard(card, match, query) {
   card.hidden = false;
   card.dataset.match = match.status === 'review' ? 'review' : match.group;
   card.dataset.hasDimensions = String(match.hasDimensions);
   const badge = card.querySelector('[data-rf-badge]');
   badge.hidden = false;
   badge.textContent = match.status === 'review' ? text.needs_confirmation : match.group === 'alternative' ? text.alternative_badge : match.hasDimensions ? (query.mode === 'space' ? text.space_badge : text.exact_badge) : text.load_badge;
   const setting = card.querySelector('[data-rf-setting]');
   setting.hidden = !match.hasDimensions;
   setting.textContent = (match.group === 'alternative' ? text.alternative_setting : text.setting) + ': ' + AXES.map(axis => fmt(match.setting[axis])).join(' × ') + ' cm';
   const delta = card.querySelector('[data-rf-differences]');
   delta.replaceChildren(); delta.hidden = !match.hasDimensions;
   for (const axis of AXES) {
    if (query[axis] === null) continue;
    const value = match.differences[axis], line = document.createElement('span');
    line.className = 'tkrf__delta tkrf__delta--'+axis;
    const details = Math.abs(value)<1e-7 ? (query.mode === 'space' ? text.no_reserve : text.exact_value) : (value<0 ? text.space_saved : text.extra_space).replace('{n}',fmt(Math.abs(value)));
    line.textContent = text[axis]+': '+details;
    delta.append(line);
   }
  }

  function inputErrors() {
   const errors = new Map(), load = toNumber(get('load').value);
   if (!get('load').value.trim()) errors.set('load',text.field_load_required);
   else if (!load || load>10000 || get('load').validity.badInput || !get('load').validity.valid) errors.set('load',get('unit').value==='jackets' && load && !Number.isInteger(load) ? text.field_jackets_integer : text.field_load_invalid);
   for (const axis of AXES) if (get(axis).value!=='' && (!toNumber(get(axis).value) || Number(get(axis).value)>1000 || !get(axis).validity.valid)) errors.set(axis,text.field_size_invalid);
   for (const field of form.querySelectorAll('input[type=number]')) {
    const message = errors.get(field.name), hint = root.querySelector('[data-rf-field-error="'+field.name+'"]');
    field.setAttribute('aria-invalid',String(Boolean(message)));
    hint.textContent = message || '';hint.hidden = !message;
   }
   return errors;
  }
  function submitSelection() {
   run(true);
   const first = form.querySelector('[aria-invalid="true"]');
   if (first) {first.scrollIntoView({block:'center',behavior:'auto'});first.focus({preventScroll:true});return;}
   count.scrollIntoView({block:'start',behavior:'auto'});count.focus({preventScroll:true});
  }
  const videoDialog=root.querySelector('[data-rf-video-dialog]'), video=videoDialog.querySelector('video');
  for (const trigger of root.querySelectorAll('[data-rf-video-url]')) trigger.addEventListener('click',()=>{
   videoDialog.querySelector('[data-rf-video-title]').textContent=trigger.dataset.rfVideoTitle;
   video.poster=trigger.dataset.rfVideoPoster;video.src=trigger.dataset.rfVideoUrl;videoDialog.showModal();
  });
  videoDialog.querySelector('[data-rf-video-close]').addEventListener('click',()=>videoDialog.close());
  videoDialog.addEventListener('close',()=>{video.pause();video.removeAttribute('src');video.removeAttribute('poster');video.load();});

  function run(save=false) {
   clearTimeout(timer); unitLabels(); dimensionMode();
   const bad = inputErrors().size > 0 || keys.some(key => get(key).validity?.badInput);
   const result = bad ? {valid:false,results:[],reviewResults:[]} : findRacks(config.records,read());
   root.querySelector('[data-rf-error]').hidden = result.valid;
   inputErrors();
   for (const card of cards) card.hidden = true;
   for (const old of grid.querySelectorAll('[data-rf-group]')) old.remove();
   review.hidden = true;
   const empty = root.querySelector('[data-rf-empty]');
   if (!result.valid) {
    count.textContent = text.check_inputs;
    root.querySelector('[data-rf-summary]').textContent = '';
    empty.hidden = true; resultCount = 0; jumpVisibility(); return;
   }
   const sorted = sortMatches(result.results,sortControl.value), active = AXES.filter(axis => result.query[axis]!==null);
   let currentGroup;
   for (const match of sorted) {
    const card = cards.find(c => c.dataset.sku === match.record.sku);
    if (!card) continue;
    card.classList.toggle('tkrf__card--featured',match.group==='exact' && result.exactCount===1);
    if (match.group !== currentGroup) {
     currentGroup = match.group;
     const heading = document.createElement('p'); heading.dataset.rfGroup = currentGroup; heading.className = 'tkrf__group';
     heading.textContent = headingFor(currentGroup); grid.append(heading);
     if (currentGroup === 'alternative') {
      const hint = document.createElement('p'); hint.dataset.rfGroup = 'alternative-help';
      hint.className = 'tkrf__group-help'; hint.textContent = text.group_alternative_help; grid.append(hint);
     }
    }
    fillCard(card,match,result.query); grid.append(card);
   }
   if (result.reviewResults.length) {
    review.hidden = false;
    root.querySelector('[data-rf-review-count]').textContent = (result.reviewResults.length===1 ? text.review_count_one : text.review_count).replace('{n}',String(result.reviewResults.length));
    for (const match of sortMatches(result.reviewResults,sortControl.value)) {
     const card = cards.find(c => c.dataset.sku===match.record.sku);
     if (card) {fillCard(card,match,result.query);reviewGrid.append(card);}
    }
   }
   resultCount = sorted.length;
   count.textContent = resultCount+' '+(result.alternativeCount ? text.selection_count : text.matching);
   empty.hidden = resultCount>0;
   const failures = AXES.filter(axis => result.excludedBy[axis]>0).map(axis => text[axis]+': '+result.excludedBy[axis]);
   root.querySelector('[data-rf-empty-reasons]').textContent = failures.length ? text.exceeded_limits+' '+failures.join(' · ') : text.empty_load;
   const sizes = active.length ? AXES.map(axis => text[axis]+': '+(result.query[axis]===null ? text.any_value : fmt(result.query[axis])+' cm')).join(' · ') : text.dimensions_any;
   root.querySelector('[data-rf-summary]').textContent = fmt(result.query.requiredKg)+' kg '+text.clothing+' · '+sizes+(active.length ? ' · '+(result.query.mode==='space' ? text.space : text.exact) : '')+(result.alternativeCount ? ' · '+text.exact_alternative_counts.replace('{exact}',String(result.exactCount)).replace('{alternative}',String(result.alternativeCount)) : '')+(get('profi').value==='yes' ? ' · '+text.profi_summary : '');
   jump.textContent = text.jump_results.replace('{n}',String(resultCount));
   jumpVisibility();
   if (save) updateUrl();
  }
  fromUrl();
  get('unit').addEventListener('change',() => {
   const next = get('unit').value, value = toNumber(get('load').value);
   if (value && next !== previousUnit) {
    const converted = next==='jackets' ? value/2.5 : value*2.5;
    const rounded = next==='jackets' ? Math.ceil(converted-1e-9) : Math.round(converted*10)/10;
    get('load').value = String(rounded);
    root.querySelector('[data-rf-rounding]').textContent = next==='jackets' && Math.abs(rounded-converted)>1e-7 ? text.rounding_notice.replace('{kg}',fmt(rounded*2.5)) : '';
   }
   previousUnit = next;
  });
  form.addEventListener('input',event => {
   if (event.target.name==='load') root.querySelector('[data-rf-rounding]').textContent = '';
   clearTimeout(timer); timer = setTimeout(() => run(true),160);
  });
  form.addEventListener('change',() => run(true));
  form.addEventListener('submit',event => {event.preventDefault();submitSelection();});
  for (const button of root.querySelectorAll('[data-rf-clear-sizes]')) button.addEventListener('click',() => {for (const axis of AXES) get(axis).value='';run(true);});
  sortControl.addEventListener('change',() => run(true));
  jump.addEventListener('click',submitSelection);
  addEventListener('scroll',() => {if (!scrollFrame) scrollFrame=requestAnimationFrame(() => {scrollFrame=null;jumpVisibility();});},{passive:true});
  addEventListener('resize',jumpVisibility,{passive:true});
  addEventListener('popstate',() => {fromUrl();run();});
  run();
 }
 document.querySelectorAll('[data-rack-finder]').forEach(init);
 document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-rack-finder]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tatkraft-shoe-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
 'use strict';
 const AXES=['width','depth','height'];
const EPS=1e-7;
function number(value){
 if(typeof value==='number')return Number.isFinite(value)&&value>0?value:null;
 if(typeof value!=='string'||!/^\d+(?:[.,]\d+)?$/.test(value.trim()))return null;
 const n=Number(value.trim().replace(',','.'));return Number.isFinite(n)&&n>0?n:null;
}
function normalize(input){
 const pairs=number(input.pairs),q={pairs,mode:input.mode??'space',sort:input.sort??'relevance'};
 if(!pairs||!Number.isInteger(pairs)||pairs>1000||!['space','exact'].includes(q.mode)||!['relevance','price','price_desc','capacity'].includes(q.sort))return null;
 for(const a of AXES){const v=input[a],empty=v==null||String(v).trim()==='';q[a]=empty?null:number(v);if(!empty&&(!q[a]||q[a]>1000))return null;}
 return q;
}
function estimatePairs(width,shoeLevels){return Math.floor((width+EPS)/18.5)*shoeLevels;}
function findShoes(records,input){
 const q=normalize(input);if(!q)return {valid:false,results:[]};
 const candidates=records.filter(r=>r.available&&r.capacityMax>=q.pairs&&[r.width,r.depth,r.height,r.capacityMax].every(v=>Number.isFinite(v)&&v>0));
 const results=[];
 for(const r of candidates){
  const differences=Object.fromEntries(AXES.map(a=>[a,q[a]===null?null:r[a]-q[a]]));
  if(q.mode==='space'&&AXES.some(a=>differences[a]!==null&&differences[a]>EPS))continue;
  const active=AXES.filter(a=>q[a]!==null),exact=active.every(a=>Math.abs(differences[a])<EPS);
  const distance=active.length?active.reduce((s,a)=>s+Math.abs(differences[a])/q[a],0)/active.length:0;
  results.push({record:r,differences,exact,distance,hasDimensions:active.length>0,group:q.mode==='exact'&&active.length?(exact?'exact':'alternative'):'matching'});
 }
 results.sort((a,b)=>{
  const g=(a.group==='alternative')-(b.group==='alternative');if(g)return g;
  if(q.sort==='price')return a.record.price-b.record.price||a.distance-b.distance;
  if(q.sort==='price_desc')return b.record.price-a.record.price||a.distance-b.distance;
  if(q.sort==='capacity')return b.record.capacityMax-a.record.capacityMax||a.record.price-b.record.price;
  return a.distance-b.distance||(a.record.capacityMax-q.pairs)-(b.record.capacityMax-q.pairs)||a.record.price-b.record.price||a.record.model.localeCompare(b.record.model);
 });
 return {valid:true,query:q,results,capacityCount:candidates.length,excludedBy:Object.fromEntries(AXES.map(a=>[a,q[a]===null?0:candidates.filter(r=>r[a]>q[a]+EPS).length]))};
}

 function init(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const config=JSON.parse(root.querySelector('[data-sf-config]').textContent),text=config.text,records=config.records;
  const form=root.querySelector('form'),grid=root.querySelector('[data-sf-grid]'),empty=root.querySelector('[data-sf-empty]'),count=root.querySelector('[data-sf-count]'),error=root.querySelector('[data-sf-error]'),summary=root.querySelector('[data-sf-summary]');
  const cards=new Map([...root.querySelectorAll('[data-sf-card]')].map(c=>[c.dataset.sku,c]));
  const fmt=v=>new Intl.NumberFormat(config.locale,{maximumFractionDigits:1}).format(Math.abs(v));
  const say=(key,values={})=>Object.entries(values).reduce((s,[k,v])=>s.replaceAll('{'+k+'}',String(v)),text[key]);
  function read(){return Object.fromEntries(new FormData(form));}
  function mode(){
   const v=form.elements.mode.value;
   root.querySelector('[data-sf-modehelp]').textContent=text[v==='space'?'space_help':'exact_help'];
   AXES.forEach(a=>root.querySelector('[data-sf-label="'+a+'"]').textContent=text[v+'_'+a]);
  }
  function persist(q){
   const url=new URL(location.href);for(const k of ['pairs','mode','width','depth','height','sort']){const v=q[k];if(v==null||v==='')url.searchParams.delete(k);else url.searchParams.set(k,v);}
   history.replaceState(null,'',url);
  }
  function group(key){const h=document.createElement('h3');h.className='tksf__group';h.textContent=text[key];grid.append(h);}
  function render({scroll=false,write=true}={}){
   mode();const result=findShoes(records,read());
   error.hidden=result.valid;grid.hidden=!result.valid;empty.hidden=true;summary.textContent='';
   root.querySelectorAll('[data-sf-result-count]').forEach(x=>x.textContent=result.valid?say('short_count',{count:result.results.length}):'');
   grid.querySelectorAll('.tksf__group').forEach(x=>x.remove());
   cards.forEach(c=>{c.hidden=true;c.classList.remove('tksf__card--featured');});
   if(!result.valid){count.textContent=text.invalid_short;if(scroll){const bad=['pairs',...AXES].find(k=>form.elements[k].value===''&&k==='pairs'||form.elements[k].value!==''&&!number(form.elements[k].value));(form.elements[bad??'pairs']).focus();}return;}
   const q=result.query,n=result.results.length;if(write)persist(q);
   count.textContent=say('results',{count:n});
   const sizes=AXES.filter(a=>q[a]!==null).map(a=>text[a]+': '+fmt(q[a])+' cm').join(' · ');
   summary.textContent=say('summary',{pairs:q.pairs})+(sizes?' · '+sizes:' · '+text.no_sizes);
   empty.hidden=n>0;root.querySelector('[data-sf-empty-reason]').textContent=result.capacityCount===0?text.empty_capacity:text.empty_space;
   root.querySelectorAll('[data-sf-clear-sizes]').forEach(b=>b.hidden=!AXES.some(a=>q[a]!==null));
   let previous=null;
   for(const [index,m] of result.results.entries()){
    if(m.group!==previous&&q.mode==='exact'&&m.hasDimensions){group(m.group==='exact'?'exact_group':'other_group');previous=m.group;}
    const c=cards.get(m.record.sku);if(!c)continue;c.hidden=false;c.classList.toggle('tksf__card--featured',index===0);c.dataset.match=m.group;grid.append(c);
    c.querySelector('[data-sf-badge]').textContent=m.group==='alternative'?text.compare_dimensions:m.hasDimensions?(q.mode==='space'?text.fits_space:text.fits_exact):text.fits_pairs;
    const deltas=c.querySelector('[data-sf-differences]');deltas.replaceChildren();deltas.hidden=!m.hasDimensions;
    for(const axis of AXES){const delta=m.differences[axis];if(delta===null)continue;const p=document.createElement('p');p.className='tksf__delta tksf__delta--'+axis;p.textContent=Math.abs(delta)<1e-7?say('same_axis',{axis:text[axis]}):delta<0?say('save_'+axis,{cm:fmt(delta)}):say('more_'+axis,{cm:fmt(delta)});deltas.append(p);}
   }
   if(scroll){count.focus({preventScroll:true});count.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  }
  const params=new URLSearchParams(location.search);
  for(const k of ['pairs','width','depth','height','sort'])if(params.has(k)){const v=params.get(k);if(k!=='sort'||['relevance','price','price_desc','capacity'].includes(v))form.elements[k].value=v;}
  if(['space','exact'].includes(params.get('mode')))form.elements.mode.value=params.get('mode');
  form.addEventListener('submit',e=>{e.preventDefault();render({scroll:true});});
  let timer;form.addEventListener('input',e=>{clearTimeout(timer);timer=setTimeout(()=>render(),180);});
  root.addEventListener('change',()=>{clearTimeout(timer);render();});
  root.querySelectorAll('[data-sf-clear-sizes]').forEach(b=>b.addEventListener('click',()=>{AXES.forEach(a=>form.elements[a].value='');render({scroll:true});}));
  root.querySelector('[data-sf-reset]').addEventListener('click',()=>{form.reset();render();form.elements.pairs.focus();});
  window.addEventListener('popstate',()=>{const p=new URLSearchParams(location.search);for(const k of ['pairs','width','depth','height','sort'])form.elements[k].value=p.get(k)??(k==='pairs'?'12':k==='sort'?'relevance':'');form.elements.mode.value=p.get('mode')==='exact'?'exact':'space';render({write:false});});
  render({write:false});
 }
 document.querySelectorAll('[data-shoe-finder]').forEach(init);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-shoe-finder]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();
})();
